import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const HeaderBlog = () => {
  const allData = useStaticQuery(graphql`
    query {
      allNavHeaderMenuJson {
        edges {
          node {
            name
            title
            slug
          }
        }
      }
    }
  `)
  const data = allData.allNavHeaderMenuJson.edges
  if (data.length <= 0) {
    return <></>
  }
  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-xl">
          <div className="nav-header">
            <button
              type="button"
              className="navbar-toggler"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-motherhost"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>

            <Link
              className="navbar-brand"
              to="/"
              title="Motherhost Logo"
              aria-label="Click here to Navigate Motherhost Home Page"
            >
              <img
                src="/img/logo/motherhost-logo-blue.svg"
                className="logo"
                alt="Motherhost logo"
              />
            </Link>
            <ul className="d-flex w-100 justify-content-end d-lg-none">
              <li className="nav-item me-1">
                <a
                  className="btn btn-mh btn-outline-primary"
                  href="mailto:support@motherhost.com"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-envelope-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                  </svg>
                </a>
              </li>
              <li className="nav-item me-1">
                <a
                  className="btn btn-mh btn-outline-primary"
                  href="tel:+919884678464"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-telephone-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                    />
                  </svg>
                </a>
              </li>
              <li className="nav-item">
                <Link
                  className="btn btn-mh btn-outline-primary"
                  role="button"
                  aria-pressed="true"
                  to="/login/"
                  title="Login with Motherhost account"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-in-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                    />
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
          <div id="navbar-motherhost" className="collapse navbar-collapse">
            <ul className="navbar-nav me-auto">
              {data.map((item, index) => (
                <li className="nav-item" key={index}>
                  <Link
                    to={item.node.slug}
                    title={item.node.title}
                    className="nav-link"
                  >
                    {item.node.name}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className="navbar-nav ms-auto d-none d-lg-flex">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Sign In
                  <i className="me-1 bi bi-chevron-down"></i>
                </a>
                <ul
                  className="dropdown-menu shadow "
                  style={{ width: "320px", padding: "24px 16px" }}
                >
                  <li>
                    <span className="mb-3 fw-bold d-block">
                      Registered Users
                    </span>
                    <span className="mb-3 d-block">
                      Have an account? Sign in now.
                    </span>
                    <Link
                      className="mt-3"
                      role="button"
                      aria-pressed="true"
                      to="/login/"
                      title="Login with Motherhost account"
                    >
                      Sign In
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider my-3" />
                  </li>
                  <li>
                    <span className="mb-3 fw-bold d-block"> New Customer</span>
                    <span className="mb-3 d-block">
                      New to Motherhost? Create an account to get started today.
                    </span>
                    <a
                      className="mt-3"
                      href="https://my.motherhost.com/register.php"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Create an Account
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a
                 href="tel:+919884678464"
                  className="nav-link d-flex"
                  
                  
                >
                  <span>
                    0988-467-8464
                    {/* <br />
                    <small style={{fontSize: "10px"}}>(24x7 Sales &amp; Support)</small> */}
                  </span>
                  <img
                    src="/img/icons/india-flag.png"
                    alt="India"
                    title="India"
                    className="ms-1"
                    height={22}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default HeaderBlog
